import axios from "axios";
import { getNewAdminAccessTokenApi } from "./authApi";

const APIURL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: APIURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});



axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminAccessToken");

    if (token) {
    
      config.headers["AuthorizationAdmin"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ================= RESPONSE ================= */

axiosInstance.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;
    const code = error.response?.data?.code;


    if (
      code === "ACCESS_TOKEN_EXPIRED" &&
      !originalRequest._retry &&
      !originalRequest.url.includes("getnewaccess-token")
    ) {
      originalRequest._retry = true;

      try {
        console.log("🔄 ADMIN REFRESH TOKEN API CALL");

        const refreshRes = await getNewAdminAccessTokenApi();

        const { accessToken, admin } = refreshRes;

        localStorage.setItem("adminAccessToken", accessToken);
        localStorage.setItem("admin", JSON.stringify(admin));

     
        console.log("response of get new acess tokoen", refreshRes);

        originalRequest.headers["AuthorizationAdmin"] =
          `Bearer ${accessToken}`;

        return axiosInstance(originalRequest);

      } catch (err) {
        console.log("ADMIN REFRESH FAILED");

        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
